import "core-js/modules/es6.array.last-index-of";
import URL from 'url-parse';
export function getFilename(url) {
  var _URL = new URL(url, {}),
      pathname = _URL.pathname;

  return pathname.substring(pathname.lastIndexOf('/') + 1);
}
export function getFileExtension(url) {
  var filename = getFilename(url);
  var dotIndex = filename.lastIndexOf('.');
  return dotIndex > 0 ? filename.substring(dotIndex) : '';
}
export function getManifestBaseUrl(manifestUrl) {
  var urlObject = new URL(manifestUrl, {});

  if (urlObject.protocol === 'exp:') {
    urlObject.set('protocol', 'http:');
  } else if (urlObject.protocol === 'exps:') {
    urlObject.set('protocol', 'https:');
  }

  var directory = urlObject.pathname.substring(0, urlObject.pathname.lastIndexOf('/') + 1);
  urlObject.set('pathname', directory);
  urlObject.set('query', '');
  urlObject.set('hash', '');
  return urlObject.href;
}